<!-- <div class="ui breadcrumb page">

  <span *ngFor="let breadcrumb of breadcrumbs">
    <a class="section" *ngIf="!isFinalLink(breadcrumb)" [routerLink]="breadcrumb.link">{{breadcrumb.text | titlecase}}</a>
    <a class="font-weight-bold" style="color: #000000 !important;" *ngIf="isFinalLink(breadcrumb)">{{breadcrumb.text | titlecase}}</a>
    <span class="divider" *ngIf="!isFinalLink(breadcrumb)">/</span>
  </span>

</div> -->

<div _ngcontent-c1="" class="ui container" sui-dropdown-group="" style="color: white;">
  <a *ngIf="role =='CAC_CRP_DATA_ENTRY_OFFICER'"  _ngcontent-c1=""  style="color:'#00ad56 '" class="item" [routerLink]="'/dashboard'"[ngClass]="{'active': activeLink=='/dashboard'}" >Dashboard
  </a>
  <a *ngIf="role !='CAC_CRP_DATA_ENTRY_OFFICER'"  _ngcontent-c1=""  style="color:'#00ad56 '" class="item" [routerLink]="'/company-registration/company-list'"[ngClass]="{'active': activeLink=='/company-registration/company-list'}" >Dashboard
  </a>
</div>
